import { useState, React } from 'react';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  useMediaQuery,
  Box,
  Grid,
  CssBaseline,
  Drawer,
  Hidden,
} from '@material-ui/core';
import TouchAppIcon from "@material-ui/icons/TouchApp";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedIn from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LogoInstorex from '../../../assets/images/InstoreX3-02.png';
import { useHistory } from 'react-router-dom'
import { ROUTES } from '../../../constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import { commercialPageConstants } from '../../../constants';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,

    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: '#FFF',
      color: '#212121'
    },
    drawer: {
      width: "100vw",

    },
    drawerPaper: {
      width: "100vw",
      minHeight: "40vh",
      overflow: "hidden",
    },
    drawerContainer: {
      overflow: "hidden",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    // title: {
    //   flexGrow: 16,
    // },
    titles: {
      fontSize: 16,
      padding: theme.spacing(1.5),
      fontFamily: 'Raleway',
      fontWeight: 'bold'
    },
    titlesActive: {
      fontSize: 16,
      padding: theme.spacing(1.5),
      fontFamily: 'Raleway',
      fontWeight: 'bold',
      textDecoration: 'underline black',
      color: 'black'
    },
    titleUnflex: {
      fontSize: 25,
      right: 0,
      position: 'abosolute',
    },
    titlesUnflex: {
      // flexGrow: 1,
      fontSize: 25,
    },
    paper: {
      padding: theme.spacing(2),
      color: '#212121',
      textAlign: 'start',
    },
    gridFlex: {
      display: 'flex',
      flexDirection: 'row',
      padding: 0,
      padding: theme.spacing(2),
      textAlign: 'center',
      color: '##212121',
    },
    gridUnFlex: {
      padding: theme.spacing(2),
      color: '##212121',
      fontSize: 10,
    },
    dropDown: {
      padding: theme.spacing(2),
      color: '#212121',
      textAlign: 'center',
      fontSize: 14,
      fontFamily: 'Raleway',
      fontWeight: 'bold'
    },
    dropDownTitle: {
      fontSize: 20,
    },
    dropDownLink: {
      textAlign: 'center',
      fontSize: 20,
      color: '#212121',
      fontWeight: 'bold',
      // flexGrow: 1,
    },
    drawerDropdown: {
      width: "100vw",
      // minHeight: "15vh",
      overflow: "hidden",

    },
    dropDownItemIcon: {
      marginLeft: "10px"
    },
    linkMenu: {
      cursor: 'pointer',
      textAlign: 'center',
      fontSize: 20,
      color: '#212121',
      fontWeight: 'bold',
      // flexGrow: 1,
      textDecoration: 'none'
    },
    logo: {
      marginLeft: 10,
      maxWidth: 200,
      maxHeight: 80,
      flexGrow: 1,
    },
    logoMobileSmall: {
      maxWidth: 100,
      maxHeight: 150,
    },
    '@global': {
      '.MuiPaper-elevation4': {
        boxShadow: 'none',
      }
    }
  }),
);

export default function ClippedDrawer(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openDD, setOpenDD] = useState(false);
  // const [selectedMenu, setSelectedMenu] = useState(1);
  const history = useHistory();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  const isMobileSmall = useMediaQuery(theme.breakpoints.up('sm'));


  const menu = useSelector(state => state.menuReducer);
  const dispatch = useDispatch();

  const handleRedirectKontaktPage = () => {
    history.push(ROUTES.KONTAKT);
    dispatch({
      type: commercialPageConstants.MENUUPDATE, payload: {
        selectedMenu: ROUTES.KONTAKT
      }
    })
  }

  const handleRedirectAboutUsPage = () => {
    history.push(ROUTES.ABOUTUS);
    dispatch({
      type: commercialPageConstants.MENUUPDATE, payload: {
        selectedMenu: ROUTES.ABOUTUS
      }
    })
  }

  const handleRedirectMusikPage = () => {
    history.push(ROUTES.MUSIK);
    dispatch({
      type: commercialPageConstants.MENUUPDATE, payload: {
        selectedMenu: ROUTES.MUSIK
      }
    })
  }

  const handleRedirectHomePage = () => {
    history.push(ROUTES.HOME);
    dispatch({
      type: commercialPageConstants.MENUUPDATE, payload: {
        selectedMenu: ROUTES.HOME
      }
    })
  }


  const handleRedirectSignagePage = () => {
    history.push(ROUTES.SIGNAGE);
    dispatch({
      type: commercialPageConstants.MENUUPDATE, payload: {
        selectedMenu: ROUTES.SIGNAGE
      }
    })
  }

  const handleRedirectMusicmindPage = () => {
    history.push(ROUTES.MUSICMIND);
    dispatch({
      type: commercialPageConstants.MENUUPDATE, payload: {
        selectedMenu: ROUTES.MUSICMIND
      }
    })
  }

  const handleRedirectLydbrandingPage = () => {
    history.push(ROUTES.LYDBRANDING);
    dispatch({
      type: commercialPageConstants.MENUUPDATE, payload: {
        selectedMenu: ROUTES.LYDBRANDING
      }
    })
  }

  const handleDrawerOpen = () => {
    setOpen(!open);
  };
  const handleDropdownDrawer = () => {
    setOpenDD(!openDD);
  };
  const routeChange = () => {
    history.push(ROUTES.LOGIN);
  }
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Grid container>
            <Grid xs={1}>
              <Typography variant="h6" className={classes.title}>
                <a href={ROUTES.HOME}>
                  <img src={LogoInstorex} alt="Instorex Logo" className={isMobileSmall ? classes.logo : classes.logoMobileSmall} />
                </a>
              </Typography>
            </Grid>
            {isMobile ? <>
              <Grid container xs={10} direction="row"
                justify="center"
                alignItems="center">
                {/* <a onClick={handleRedirectLydbrandingPage} className={classes.dropDownLink} */}
                {/* style={{ textDecoration: 'none' }} > */}
                {/* <Button onClick={handleRedirectLydbrandingPage} className={menu.selectedMenu === ROUTES.LYDBRANDING ? classes.titlesActive : classes.titles}>
                  Hjem
                </Button> */}
                {/* </a> */}
                <Button onClick={handleRedirectHomePage} className={menu.selectedMenu === ROUTES.HOME ? classes.titlesActive : classes.titles}>
                  Hjem
                </Button>
                <Button onClick={handleRedirectMusikPage} className={menu.selectedMenu === ROUTES.MUSIK ? classes.titlesActive : classes.titles}>
                  Musik
                </Button>
                <Button onClick={handleRedirectSignagePage} className={menu.selectedMenu === ROUTES.SIGNAGE ? classes.titlesActive : classes.titles}>
                  Signage
                </Button>
                {isMobileSmall ? <>
                  <Button className={classes.dropDown} onClick={handleDropdownDrawer}>
                    Musicmind
                    {!openDD ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                  </Button>
                </>
                  : <Typography variant="h6" className={classes.dropDown} onClick={handleDropdownDrawer}>
                    {!openDD ? <ArrowDropDownIcon style={{ fontSize: 30 }} /> : <ArrowDropUpIcon style={{ fontSize: 30 }} />}
                  </Typography>
                }
                <Button onClick={handleRedirectAboutUsPage} className={menu.selectedMenu === ROUTES.ABOUTUS ? classes.titlesActive : classes.titles}>
                  Om Os
                </Button>
                {/* <a onClick={handleRedirectKontaktPage} className={classes.linkMenu}> */}
                <Button onClick={handleRedirectKontaktPage} className={menu.selectedMenu === ROUTES.KONTAKT ? classes.titlesActive : classes.titles}>
                  Kontakt
                </Button>
                {/* </a> */}

              </Grid>
            </>
              : ""}
            <Grid xs={1}>
              <Button color="primary"
                variant="contained"
                size="large"
                startIcon={<TouchAppIcon />}
                onClick={routeChange}>
                Login
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {isMobile ?
        <>
          <Drawer
            anchor="top"
            className={classes.drawer}
            variant="persistent"
            open={open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <Toolbar />
            <div className={classes.drawerContainer}>
              <Grid container spacing={2} >
                <Grid item xs={12} >
                  <Box className={isMobile ? classes.gridFlex : classes.gridUnFlex}>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      IT Solutions
                    </Typography>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      Human Solutions
                    </Typography>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      Blog
                    </Typography>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      About Us
                    </Typography>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      Careers
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box className={classes.paperGrid1} className={classes.paper}>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box className={classes.paper}>
                    <Box borderBottom={1} style={{ color: 'gray' }}>
                      <Typography className={classes.titles} >
                        Other Links
                      </Typography>
                    </Box>
                    <Typography variant="h6" className={classes.titles}>
                      Online Catalog
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      My Account
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Contact
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Terms & Conditions
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box className={classes.paper}>
                    <Box borderBottom={1}>
                      <Typography className={classes.titles} style={{ color: 'gray' }} >
                        Industries
                      </Typography>
                    </Box>
                    <Typography variant="h6" className={classes.titles}>
                      Medium Enterprise
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Large Enterprise
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Education
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Government
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Health Care
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box className={classes.paper} >
                    <FacebookIcon />
                    <LinkedIn />
                    <YouTubeIcon />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box className={classes.paper}  >
                    <Typography>
                      Toll Fee
                      <br />
                      1-666-1234-123
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box className={classes.paper}  >
                    <Typography>
                      IT Quebec
                      <br />
                      1-666-1234-123
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box className={classes.paper}  >
                    <Typography>
                      IT Montreal
                      <br />
                      1-666-1234-123
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Drawer>
        </> :
        <>
          <Drawer
            anchor="top"
            className={classes.drawer}
            variant="persistent"
            open={open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <Toolbar />
            <div >
              <Grid container spacing={2} >
                <Grid item xs={12} >
                  <Box className={isMobile ? classes.gridFlex : classes.gridUnFlex}>
                    <Hidden xsDown>
                      <Typography variant="h6" className={classes.title}>
                        Instorex
                      </Typography>
                    </Hidden>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      IT Solutions
                    </Typography>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      Human Solutions
                    </Typography>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      Blog
                    </Typography>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      About Us
                    </Typography>
                    <Typography variant="h6" className={isMobile ? classes.titles : classes.titlesUnflex}>
                      Careers
                    </Typography>
                    <Hidden xsDown>
                      <Typography variant="h6" className={classes.titlesUnflex}>
                        Fr
                      </Typography>
                    </Hidden>
                  </Box>

                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box className={classes.paperGrid1} className={classes.paper}>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box className={classes.paper}>
                    <Box borderBottom={1} style={{ color: 'gray' }}>
                      <Typography className={classes.titles} >
                        Other Links
                      </Typography>
                    </Box>
                    <Typography variant="h6" className={classes.titles}>
                      Online Catalog
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      My Account
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Contact
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Terms & Conditions
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box className={classes.paper}>
                    <Box borderBottom={1}>
                      <Typography className={classes.titles} style={{ color: 'gray' }} >
                        Industries
                      </Typography>
                    </Box>
                    <Typography variant="h6" className={classes.titles}>
                      Medium Enterprise
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Large Enterprise
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Education
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Government
                    </Typography>
                    <Typography variant="h6" className={classes.titles}>
                      Health Care
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box className={classes.paper} >
                    <FacebookIcon />
                    <LinkedIn />
                    <YouTubeIcon />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box className={classes.paper}  >
                    <Typography>
                      Toll Fee
                      <br />
                      1-666-1234-123
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box className={classes.paper}  >
                    <Typography>
                      IT Quebec
                      <br />
                      1-666-1234-123
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box className={classes.paper}  >
                    <Typography>
                      IT Montreal
                      <br />
                      1-666-1234-123
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Drawer>
        </>}
      <Drawer
        anchor="top"
        className={classes.drawer}
        variant="persistent"
        open={openDD}
        classes={{
          paper: classes.drawerDropdown,
        }}
      >
        <>
          <Toolbar />
          <div className={classes.drawerContainer}>
            <Grid container spacing={2}>
              {/* <Grid xl={12} md={4}  >
                <Box className={classes.dropDown}>
                  <Typography className={classes.dropDownTitle}>
                    TEST TEST TEST
                  </Typography>
                </Box>
              </Grid> */}
              <Grid container
                direction="column"
                alignItems="center"
                justify="center" style={{ margin: 25 }} >
                <Box className={classes.dropDown}>
                  <a onClick={handleRedirectMusicmindPage} className={classes.dropDownLink}
                    style={{ textDecoration: 'none', cursor: "pointer" }}>
                    <Typography className={classes.dropDownTitle}>
                      About Musicmind
                    </Typography>
                  </a>
                  <a href={`${process.env.REACT_APP_MUSICMIND_URL}`} className={classes.dropDownLink}
                    style={{ textDecoration: 'none' }}>
                    <Typography className={classes.dropDownTitle}>
                      Login to Musicmind
                      <ExitToAppIcon className={classes.dropDownItemIcon} />
                    </Typography>
                  </a>
                  {/* <a href="/" className={classes.dropDownLink}
                    style={{ textDecoration: 'none' }}>
                    <Typography className={classes.dropDownTitle}>
                      Lorem Ipsum
                    </Typography>
                  </a> */}
                </Box>
              </Grid>
              {/* <Grid xl={12} md={4}  >
                <Box className={classes.dropDown}>
                  <Typography className={classes.dropDownTitle}>

                  </Typography>
                </Box>
              </Grid> */}
            </Grid>

          </div>
        </>
      </Drawer>
    </div>
  );
}